import { Link } from "react-router-dom";
import { cases } from "@/mocks/cases";
import SectionTitle from "@/components/base/SectionTitle";

export default function CasesPreview() {
  const shown = cases.slice(0, 3);
  return (
    <section id="case" className="bg-secondary-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-10">
        <SectionTitle
          eyebrow="Case Studies"
          title="事例紹介"
          description="実際に対応した事例をお伝えいたします。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {shown.map((c) => (
            <Link
              key={c.slug}
              to={`/cases`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-3 left-3 bg-primary-900/85 backdrop-blur px-3 py-1.5 rounded-md text-xs text-background-50 flex items-center gap-2">
                  <i className="ri-price-tag-3-line"></i>
                  {c.category}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600 mb-3">
                  <span className="flex items-center gap-1"><i className="ri-map-pin-line"></i>{c.location}</span>
                  <span className="flex items-center gap-1"><i className="ri-building-2-line"></i>{c.scale}</span>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 leading-snug mb-3">
                  {c.title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3">
                  {c.result}
                </p>
                <div className="mt-4 flex items-center text-sm text-primary-600 group-hover:text-primary-700">
                  事例を読む <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}